import {AutorunComponent} from '@myshared/autorun.component';
import {Component, Input,} from '@angular/core';
import {GetInvoiceAttachmentResponse, Invoice, InvoiceAttachment_Type} from '@proto/odoo/invoice';
import {InvoiceService} from '../invoice.service';

@Component({
    selector: 'app-invoice-card',
    templateUrl: './invoice-card.component.html',
    standalone: false
})
export class InvoiceCardComponent extends AutorunComponent {
    @Input()
    public invoice: Invoice;

    constructor(private invoiceService: InvoiceService) {
        super();
    }

    public getProductNameForPreview() {
        const matches = this.invoice.product.match(/\[PC-(.*?)]/);
        let result: string;
        if (matches != null) {
            result = matches[1];
        } else {
            result = this.invoice.product;
        }
        if (result.length >= 50) {
            result = result.substr(0, 47).concat('...');
        }
        return result;
    }

    public getFormatFromType(type: InvoiceAttachment_Type) {
        if (type === InvoiceAttachment_Type.INVOICE_PDF) {
            return 'invoice_pdf';
        } else if (type === InvoiceAttachment_Type.INVOICE_XRECHNUNG) {
            return 'invoice_xrechnung';
        }  else if (type === InvoiceAttachment_Type.ITEMIZED_BILL_PDF) {
            return 'itemized_bill_pdf';
        } else {
            return 'unknown';
        }
    }

    public download(id: number) {
        this.invoiceService.getInvoiceAttachments(this.invoice.id, id).subscribe({
            next: (result: GetInvoiceAttachmentResponse) => {
                window.open(result.presignedUrl);
            }
        })
    }
}
